module.exports = __webpack_public_path__ + "static/media/480.89b89aee.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/services/img/i8-bumblebee/light/480.png
// module id = 1900
// module chunks = 2